<template>
    <div style="height:100%">
        <div id="csContainer">
            <div class="fogdiv">
                <div class="shadow">
                    <el-checkbox size="small " v-model="enableContour" label="显示等高线" border></el-checkbox>
                    <el-checkbox size="small " v-model="slope" label="显示坡度" border></el-checkbox>
                    <br/>
                    <span > 等高线间距:{{contourSpacing}}</span>
                    <el-slider v-model="contourSpacing"  :min="1" :max="1000" :step="10"show-input input-size="mini"></el-slider>
                    <span > 等高线宽度:{{contourWidth}}</span>
                    <el-slider v-model="contourWidth"  :min="1" :max="10" :step="1"show-input input-size="mini"></el-slider>
                    <el-button  size="small" type="primary" @click="changeColor()" >改变等高线颜色</el-button>
                </div>
            </div>

        </div>
        <div id="loadingOverlay"><h1>Loading........</h1></div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        data() {
            return {
                viewer: null,
                contourColor: Cesium.Color.RED.clone(),
                //是否显示等高线
                enableContour: true,
                slope:false,
                contourSpacing: 150.0,
                contourWidth: 2.0,
                //不显示底色
                selectedShading: 'none',
                contourUniforms: {},
                // 三种着色
                elevationRamp: [0.0, 0.045, 0.1, 0.15, 0.37, 0.54, 1.0],
                slopeRamp: [0.0, 0.29, 0.5, Math.sqrt(2) / 2, 0.87, 0.91, 1.0],
                aspectRamp: [0.0, 0.2, 0.4, 0.6, 0.8, 0.9, 1.0]
            }
        },
        watch:{
            enableContour:function (val) {
                this.updateMaterial();
            },
            contourSpacing:function (val) {
                this.updateMaterial();
            },
            contourWidth:function (val) {
                this.updateMaterial();
            },
            slope:function (val) {
                if (val === true){
                    this.selectedShading = 'slope';
                    this.updateMaterial();
                }else if(val === false){
                    this.selectedShading = 'none';
                    this.updateMaterial();
                }
            }

        },
        mounted() {
        var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
       },4000);
            this.init();
        },
        methods: {
            init() {
                let viewer = util.getViewer("csContainer",{
                    contextOptions: {
                        webgl: {
                            alpha: true
                        }
                    },
                    homeButton: false,
                    sceneModePicker: false,
                    baseLayerPicker: false,
                });
                viewer.terrainProvider = Cesium.createWorldTerrain({
                    requestVertexNormals: true,

                });
                viewer.scene.globe.enableLighting = true;
                this.viewer = viewer;
                util.setViewHill(viewer);
                this.updateMaterial();
            },
            updateMaterial() {
                let viewer = this.viewer;
                let hasContour = this.enableContour; // 是否绘制等高线
                let selectedShading = this.selectedShading;  // 选择模式
                let globe = viewer.scene.globe;
                let material;

                let shadingUniforms = {}; //   函数定义

                let minHeight = -414.0; // approximate dead sea elevation
                let maxHeight = 8777.0; // approximate everest elevation
                if (hasContour) {
                    if (selectedShading === 'elevation') {
                        material = this.getElevationContourMaterial();
                        // 获取uniforms
                        shadingUniforms = material.materials.elevationRampMaterial.uniforms;
                        shadingUniforms.minimumHeight = minHeight;
                        shadingUniforms.maximumHeight = maxHeight;
                        this.contourUniforms = material.materials.contourMaterial.uniforms;
                    } else if (selectedShading === 'slope') {
                        material = this.getSlopeContourMaterial();
                        shadingUniforms = material.materials.slopeRampMaterial.uniforms;
                        this.contourUniforms = material.materials.contourMaterial.uniforms;
                    } else if (selectedShading === 'aspect') {
                        material = this.getAspectContourMaterial();
                        shadingUniforms = material.materials.aspectRampMaterial.uniforms;
                        this.contourUniforms = material.materials.contourMaterial.uniforms;
                    } else {
                        material = Cesium.Material.fromType('ElevationContour');
                        this.contourUniforms = material.uniforms;
                    }
                    this.contourUniforms.width = this.contourWidth;
                    this.contourUniforms.spacing = this.contourSpacing;
                    this.contourUniforms.color = this.contourColor;
                } else if (selectedShading === 'elevation') {
                    material = Cesium.Material.fromType('ElevationRamp');
                    shadingUniforms = material.uniforms;
                    shadingUniforms.minimumHeight = minHeight;
                    shadingUniforms.maximumHeight = maxHeight;
                } else if (selectedShading === 'slope') {
                    material = Cesium.Material.fromType('SlopeRamp');
                    shadingUniforms = material.uniforms;
                } else if (selectedShading === 'aspect') {
                    material = Cesium.Material.fromType('AspectRamp');
                    shadingUniforms = material.uniforms;
                }
                if (selectedShading !== 'none') {
                    shadingUniforms.image = this.getColorRamp(selectedShading);
                }
                globe.material = material;
            },
            getElevationContourMaterial() {
                // Creates a composite material with both elevation shading and contour lines
                return new Cesium.Material({
                    fabric: {
                        type: 'ElevationColorContour',
                        materials: {
                            contourMaterial: {
                                type: 'ElevationContour'
                            },
                            elevationRampMaterial: {
                                type: 'ElevationRamp'
                            }
                        },
                        components: {
                            diffuse: 'contourMaterial.alpha == 0.0 ? elevationRampMaterial.diffuse : contourMaterial.diffuse',
                            alpha: 'max(contourMaterial.alpha, elevationRampMaterial.alpha)'
                        }
                    },
                    translucent: false
                });
            },
            getSlopeContourMaterial() {
                // Creates a composite material with both slope shading and contour lines
                return new Cesium.Material({
                    fabric: {
                        type: 'SlopeColorContour',
                        materials: {
                            contourMaterial: {
                                type: 'ElevationContour'
                            },
                            slopeRampMaterial: {
                                type: 'SlopeRamp'
                            }
                        },
                        components: {
                            diffuse: 'contourMaterial.alpha == 0.0 ? slopeRampMaterial.diffuse : contourMaterial.diffuse',
                            alpha: 'max(contourMaterial.alpha, slopeRampMaterial.alpha)'
                        }
                    },
                    translucent: false
                });
            },
            getAspectContourMaterial() {
                // Creates a composite material with both aspect shading and contour lines
                return new Cesium.Material({
                    fabric: {
                        type: 'AspectColorContour',
                        materials: {
                            contourMaterial: {
                                type: 'ElevationContour'
                            },
                            aspectRampMaterial: {
                                type: 'AspectRamp'
                            }
                        },
                        components: {
                            diffuse: 'contourMaterial.alpha == 0.0 ? aspectRampMaterial.diffuse : contourMaterial.diffuse',
                            alpha: 'max(contourMaterial.alpha, aspectRampMaterial.alpha)'
                        }
                    },
                    translucent: false
                });
            },
            changeColor() {
                this.contourUniforms.color = Cesium.Color.fromRandom({alpha: 1.0}, this.contourColor);
            },
            // 创建ramp
            getColorRamp(selectedShading) {
                let ramp = document.createElement('canvas');
                ramp.width = 100;
                ramp.height = 1;
                let ctx = ramp.getContext('2d');

                let values;
                if (selectedShading === 'elevation') {
                    values = this.elevationRamp;
                } else if (selectedShading === 'slope') {
                    values = this.slopeRamp;
                } else if (selectedShading === 'aspect') {
                    values = this.aspectRamp;
                }

                let grd = ctx.createLinearGradient(0, 0, 100, 0);
                grd.addColorStop(values[0], '#000000'); //black
                grd.addColorStop(values[1], '#2747E0'); //blue
                grd.addColorStop(values[2], '#D33B7D'); //pink
                grd.addColorStop(values[3], '#D33038'); //red
                grd.addColorStop(values[4], '#FF9742'); //orange
                grd.addColorStop(values[5], '#ffd700'); //yellow
                grd.addColorStop(values[6], '#ffffff'); //white

                ctx.fillStyle = grd;
                ctx.fillRect(0, 0, 100, 1);

                return ramp;
            }
        }
    }
</script>

<style scoped>
    .fogdiv {
        font-size: 5px;
        position: absolute;
        margin-left: 25px;
        margin-top: 7px;
        z-index: 999;
        width:270px;
        /*height: 120px;*/
        background-color: rgba(0, 0, 0, 0.5);
    }
    .shadow{
        margin: 10px !important;
        color:white !important;
    }
    #csContainer {
        height: 100%;
    }
</style>
